export default __webpack_public_path__ + "images/c48cf8f837951a0c1dbbc51130873c85-habit-tracker.svg";